import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TicketsModule } from './tickets.module';
import { DashboardComponent, FooterComponent, HeaderComponent,
  SkeletonComponent } from '../components';
import { ServiceRequestModule } from './service-request.module';
import { AlertsModule } from './alerts.module';

import { DashboardRoutingModule } from '../routes/dashboard-routing.module';
import { SharedModule } from './shared.module';
import { CoreTemplateModule } from './core.module';
import { DashTicketComponent } from '../components/dashboard/dashTicket/dash-ticket.component';
import { DashAlertComponent } from '../components/dashboard/dashAlert/dash-alert.component';
import { DashServiceRequestComponent } from '../components/dashboard/dashServiceRequest/dash-service-request.component';

@NgModule({
  declarations: [
    DashboardComponent,
    DashTicketComponent,
    DashAlertComponent,
    DashServiceRequestComponent,
  ],
  exports: [
    DashboardComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    DashboardRoutingModule,
    TicketsModule,
    ServiceRequestModule,
    AlertsModule,
    
  ]

})
export class DashboardModule { }
